import React from 'react';
import { AlertTriangleIcon, StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { planes } from '../data/content';
type PricingSectionProps = {
  id?: string;
  eyebrow: string;
  heading: string;
};
export function PricingSection({
  id,
  eyebrow,
  heading
}: PricingSectionProps) {
  return <section id={id} className="w-full bg-ink py-16 sm:py-20" aria-labelledby={`${id ?? 'precios'}-title`} data-id="element-132" data-mp="1jas1op84il0h">
      <div className="mx-auto max-w-readable px-5 sm:px-8" data-id="element-133" data-mp="1s93xr6rreb0b">
        <div className="mx-auto max-w-2xl text-center" data-id="element-134" data-mp="1sbq3r1z04igf">
          <p className="font-display text-sm font-bold uppercase tracking-[0.28em] text-flame" data-id="element-135" data-mp="1x9rpxvrq4xw4">
            ⏰ {eyebrow}
          </p>
          <h2 id={`${id ?? 'precios'}-title`} className="mt-4 font-display text-3xl font-extrabold text-cream sm:text-4xl" data-id="element-136" data-mp="225qjdxrwt63e">
            {heading}
          </h2>
          <div className="mt-7" data-id="element-137" data-mp="7u1y7dv347ak">
            <Countdown data-id="element-138" data-mp="1mgentl4weydl" />
          </div>
          <p className="mt-4 flex items-center justify-center gap-2 text-sm font-semibold text-flame" data-id="element-139" data-mp="1mhg9ejjjj39k">
            <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-140" data-mp="1hp6fksfb1j20" />
            Después sube $6.000 ARS. No vuelve.
          </p>
        </div>

        <div className="mt-12 grid gap-6 lg:grid-cols-2" data-id="element-141" data-mp="17rsblsakimql">
          {planes.map(plan => {
          const featured = plan.badge !== null;
          return <article key={plan.id} className={`relative flex h-full flex-col rounded-2xl p-7 sm:p-8 ${featured ? 'border-2 border-leaf bg-ink-800' : 'border border-ink-600 bg-ink-800/60'}`} data-id="element-142" data-mp="25er73zpixomw">
                {featured && <p className="absolute -top-3.5 left-7 flex items-center gap-1.5 rounded-full bg-leaf px-3 py-1 font-display text-[11px] font-extrabold uppercase tracking-wider text-white" data-id="element-143" data-mp="k2pjfqib5bhu">
                    <StarIcon className="h-3 w-3 fill-white" aria-hidden="true" data-id="element-144" data-mp="hh8bbhwc6b9n" />
                    {plan.badge}
                  </p>}
                <p className="font-display text-xs font-bold uppercase tracking-[0.24em] text-cream/45" data-id="element-145" data-mp="7kdgb8z9ut04">
                  {plan.kicker}
                </p>
                <h3 className={`mt-2 font-display font-extrabold leading-tight ${featured ? 'text-2xl text-cream sm:text-3xl' : 'text-2xl text-cream'}`} data-id="element-146" data-mp="ckhx7043dpqv">
                  {plan.name}
                </h3>
                <p className="mt-3 text-[15px] text-cream/70" data-id="element-147" data-mp="3px1r1uiufipn">
                  {plan.includes}
                </p>

                <div className="mt-7 flex flex-wrap items-baseline gap-3" data-id="element-148" data-mp="3byv1r2rymr1l">
                  <span className="font-display text-lg font-bold text-cream/40 line-through" data-id="element-149" data-mp="3fz5fj1lzulr0">
                    {plan.before}
                  </span>
                  <span className={`font-display font-extrabold text-cream ${featured ? 'text-5xl' : 'text-4xl'}`} data-id="element-150" data-mp="2xbd6sw479asd">
                    {plan.price}
                  </span>
                  <span className="text-sm font-semibold uppercase text-cream/50" data-id="element-151" data-mp="31cf6tf5xxqve">
                    ARS
                  </span>
                </div>

                <div className="mt-auto pt-8" data-id="element-152" data-mp="3g7usowwdaggp">
                  <CtaButton href={plan.href} checkoutValue={plan.value} size={featured ? 'lg' : 'md'} data-id="element-153" data-mp="3bbnvptly8faw">
                    {plan.cta}
                  </CtaButton>
                </div>
              </article>;
        })}
        </div>

        <p className="mt-8 text-center text-[13px] text-cream/50" data-id="element-154" data-mp="2vko1nuu6qmk">
          🔒 Pago 100% seguro · ⚡ Acceso en 5 minutos · 🛡️ Garantía 7 días ·
          💳 Mercado Pago | Tarjeta | Transferencia
        </p>
      </div>
    </section>;
}